<template>
    <div class="bg-dark-create" :class="[showmodal ? 'open' : '']"></div>
    <div class="form-create-module" :class="[showmodal ? 'open' : '']">
        <div class="modal" tabindex="-1">
            <div class="modal-dialog">
                <Loader :isActive=!hasReady />
                <div class="modal-content create-lesson">
                    <div class="modal-header">
                        <h5 class="modal-title">Nova atividade</h5>
                    </div>
                    

                    <div class="modal-body">
                        <div class="form-group">
                            <div class="form-label">
                                <label class="label-form">
                                    Nome 
                                    <v-tooltip text="Campo obrigatório" location="top">
                                        <template v-slot:activator="{ props }">
                                          <i v-bind="props" class="pi pi-exclamation-circle"></i>
                                        </template>
                                      </v-tooltip>
                                </label>
                            </div>
                            <div class="form-input">
                                <input v-model="nameModule" type="text" class="form-control"
                                    placeholder="Atividade 1...">
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label class="label-form">
                                Tipo
                                <v-tooltip text="Campo obrigatório" location="top">
                                    <template v-slot:activator="{ props }">
                                      <i v-bind="props" class="pi pi-exclamation-circle"></i>
                                    </template>
                                  </v-tooltip>
                            </label>
                            <select v-model="typefile" class="select-mode">
                                <option value="" disabled selected>Selecione o tipo</option>
                                <option value="1">Videoteca</option>
                                <option value="2">Youtube</option>
                                <option value="3">Vimeo</option>
                                <option value="4">Material PDFs</option>
                                <option value="5">Quiz</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-body" v-show="typefile == 5">
                        <div class="form-group">
                            <div class="form-label">
                                <label>
                                    Selecione o Quiz

                                </label>
                            </div>
                            <div class="row align-center">
                                <div class="col-form-inner col-7 col-md-7 col-lg-7">
                                    <select v-model="quiz" class="select-mode" >
                                        <option value="" disabled selected>Selecione o Quiz</option>
                                        <option v-for="quiz in listQuiz" :value="(quiz.id)" :key="quiz.id">{{ quiz.title }}</option>
                                    </select>
                            </div>
                            <div class="button_quiz col-form-inner col-5 col-md-5 col-lg-5">
                                <button type="button" class="btn btn-warning" @click="goEditQuestions()" :disabled="quiz==''? true : false">Questões</button>
                                <button type="button" class="btn btn-primary" @click="goCreateQuiz()">Criar</button>
                            </div>  
                        </div>                          
                        </div>
                    </div>
                    <div class="modal-body" v-show="typefile == 2 || typefile == 3">
                        <div class="form-group">
                            <div class="form-label">
                                <label>
                                    Link
                                </label>
                            </div>
                            <div class="form-input">
                                <input v-model="link" type="text" class="form-control" placeholder="https://...">
                            </div>
                        </div>
                    </div>
                    <div class="modal-body plans" v-show="typefile == 1 && assinante == false">
                        <div class="form-group">
                            <label class="label-form">
                                Planos
                            </label>
                            <select class="select-mode">
                                <option value="" disabled selected>Selecione o tipo</option>
                                <option value="videoteca">1 hora</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <button class="btn-add-module">Pagar</button>
                        </div>
                    </div>
                    <div class="modal-body" v-show="typefile == 1 && assinante == true">
                        <div class="form-group" v-for="index in 5 " :key="index">
                            <div class="form-input">
                                <div class="input-group">
                                    <div class="input-group-text">
                                        <input class="form-check-input mt-0" type="radio" value="video"
                                            aria-label="Radio button for following text input">
                                    </div>
                                    <div class="form-label">
                                        <label>
                                            Nome do Video {{ index }}
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="modal-body" v-show="typefile == 4">
                        <div class="form-group">
                            <div class="form-label">
                                <label>
                                    Arquivos
                                </label>
                            </div>
                            <div class="form-file">
                                <div class="primary uploadFile">
                                    <input @change="handleFileUpload" class="form-control" type="file" accept=".pdf">
                                    <div class="loaderSpinner" v-show="loadUploadFile"></div>
                                    <i class="pi pi-check" v-show="hasReadyUpload"></i>
                                    <button v-if="selectedFile" @click="removeFile" class="btn btn-danger">Remover Arquivo</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="legenda">
                        <small><strong>Videoteca:</strong> Adicione vídeos armazenados em sua videoteca pessoal, organizados para fácil acesso e visualização.</small>
                        <small><strong>YouTube:</strong> Integre vídeos diretamente do YouTube para enriquecer suas aulas com conteúdo multimídia.</small>
                        <small><strong>Vimeo:</strong> Explore vídeos hospedados no Vimeo.</small>
                        <small><strong>Material PDFs:</strong> Anexe documentos em PDF, como apostilas, apresentações e outros materiais de apoio.</small>
                        <small><strong>Quiz:</strong> Crie quizzes interativos para avaliar o conhecimento dos alunos e reforçar o aprendizado.</small>
                    </div>
                   
                    <div class="modal-footer">
                        <button type="button" @click="closetab()" class="btn btn-secondary"
                            data-bs-dismiss="modal">Cancelar</button>
                        <button type="button" @click="saveModule()" class="btn btn-primary" :disabled="!hasReadyUpload && typefile==4">Salvar</button>
                     </div>
                </div>
            </div>
        </div>
        <Createquiz :idQuiz="quiz" :show="openmodalcreatequiz" @open-tab="atualizarValorNoFilho" @create-quiz="setLastQuiz"/>
        <ViewQUestions :idQuiz="quiz" :show="openmodalviewquestions" @open-tab="atualizarValorNoFilho2"/>
    </div>
</template>
<script>

import Createquiz from './createquiz.vue'
import ViewQUestions from './viewquestions.vue'
import { mapState } from 'vuex';
import api from '@/utils/lesson'
import apiQuiz from '@/utils/quiz'
import Loader from '@/components/Loader/loader.vue';
import apiAWS from '@/utils/storage/aws';

export default {
    data() {
        return {
            showmodal: '',
            nameModule: '',
            demo: '',
            typefile: '',
            index: 5,
            assinante: false,
            selectedFile: null,
            quiz:'',
            listQuiz:null,
            link:'',
            openmodalviewquestions:false,
            openmodalcreatequiz:false,
            hasReady:false,
            orderLesson:null,
            loadUploadFile:false,
            hasReadyUpload:false,
        }
    },
    components:{
        Createquiz,
        ViewQUestions,
        Loader
    },
    props: {
        show: Boolean,
        id: Number,
        moduleId:Number,
        lastOrder: Number
    },
    computed:{
        ...mapState(['token'])
    },
    methods: {
        async putFileAws(url, file){
          try {
              const response = await apiAWS.putFileAWS(url, file);
          } catch (error) {
              console.error('Erro ao enviar arquivo para AWS');
          }
        },
        async handleFileUpload(event){
            this.loadUploadFile = true;
            const file = event.target.files[0];
            this.imagePreview = URL.createObjectURL(file)

            const formData = new FormData();
            formData.append('file', this.imagePath);

            try {
                const response =  await apiAWS.getSignaturePdf(this.token, file.name);
                this.putFileAws(response.url)
                this.link = response.token;
                this.loadUploadFile = false;
                this.hasReadyUpload = true;

            } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
        closetab() {
            this.showmodal = false;
            this.$emit('open-tab', this.showmodal)
        },
        opentab() {
            this.showmodal = false;
            this.$emit('open-tab', this.showmodal)
        },
        saveModule() {
            this.hasReady = true;
            this.createLesson();
            this.nameModule = '';
            this.typefile = '';
            this.quiz = '';
            this.link = '';
            this.selectedFile = null;
            setTimeout(() => {
                this.showmodal = !this.showmodal;
                this.$emit('open-tab', this.showmodal)
              }, 1000);
           
        },
        removeFile() {
            this.selectedFile = null;
        },
        handleFileChange(event) {
            this.selectedFile = event.target.files[0];   
        }, 
        goCreateQuiz(){  
           this.openmodalcreatequiz = !this.openmodalcreatequiz;
        },
        goEditQuestions(){          
            this.openmodalviewquestions = !this.openmodalviewquestions;
        },
        atualizarValorNoFilho(novoValor) {
            this.openmodalcreatequiz = novoValor;
        },
        atualizarValorNoFilho2(novoValor2) {
            this.openmodalviewquestions = novoValor2;
        },
        async getDataQuiz(){
            try {
                const response = await apiQuiz.getDataQuiz(this.token);
                console.debug('Quiz', response)
                this.listQuiz =  response;
                this.hasReady = true;
            } catch (error) {
                console.error('Erro ao gerar listagem de quiz', error)
            }
        },
        createLesson(){
            const obj = {
                "module": {
                    "id": this.moduleId
                },
                "type": this.typefile,
                "title": this.nameModule,
                "status": 1,
                // "order": this.lastOrder+1,
            };
            if (this.link) {
                obj.path = this.link; 
            }
            if (this.quiz) {
                obj.quiz = {
                    "id": this.quiz
                };
            }
            try {
                const response = api.createNewLesson(obj, this.token)
            } catch (error) {
                console.error('Erro ao criar atividade', error)
            }
        },
        setLastQuiz(newValue) {
            this.quiz = newValue; // Atualizar a propriedade `quiz` com o ID do novo quiz
        },
    },
    watch: {
        show(novoValor) {
            this.showmodal = this.show;
            if(this.show == true){
                this.getDataQuiz();
            }
        },
        openmodalcreatequiz(){
            setTimeout(() => {
            this.getDataQuiz();
            }, 1000); 
        }
    },
    // created(){
    //     this.getDataQuiz()
    // },
};
</script>

<style scoped>
@import './tabs.css';

.modal-content.create-lesson .form-group .form-label label {
    display: block;
}
.loaderSpinner {
    z-index: 999999;
    /* position: absolute; */
    top: 50%;
    left: 50%;
    width: 30px;
    height: 30px;
    border: 3px solid #aeaeae;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation-1e22049d 1s linear infinite;
    z-index: 99999;
    }
  
    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 
    .primary.uploadFile {
        justify-content: left;
        gap: 15px;
        align-items: center;
    }
    .primary.uploadFile i.pi.pi-check {
        color: green;
        font-size: 25px;
    }
</style>
